import Cookies from "js-cookie";
export class Popup {
  /**
   * @private
   * @type {number}
   */
  animationDuration = 600;
  /**
   * @private
   * @type {WeakMap<HTMLElement, number>}
   */
  closeTimers = new WeakMap();

  /**
   * Click handlers are delegated to document, so they can be attached
   * before DOMContentLoaded and catch clicks while the page is still loading.
   */
  initListeners() {
    this.openInit();
    this.closeInit();
  }

  init() {
    this.openDefaultPopup();
  }

  /**
   * @private
   */
  openInit() {
    document.addEventListener("click", (e) => {
      /**
       *
       * @type {HTMLElement}
       */
      const target = e.target.closest(".popup-open");
      if (!target) return;
      e.preventDefault();
      /**
       *
       * @type {string}
       */
      const href = target.getAttribute("href");
      /**
       *
       * @type {string}
       */
      const dataPopup = target.dataset["popup"];

      /**
       * @type {HTMLElement}
       */
      let popup;

      if (href && href !== "#") {
        popup = document.querySelector(href);
      }

      if (dataPopup) {
        popup = document.querySelector(`#${dataPopup}`);
      }

      if ((!href && !dataPopup) || !popup) {
        console.error("Couldn't find a popup");
        return;
      }

      this.open(popup);
    });
  }

  /**
   * @private
   */
  closeInit() {
    document.addEventListener("click", (e) => {
      if (
        e.target.matches(".popup-close") ||
        e.target.closest(".popup-close")
      ) {
        e.preventDefault();
        /**
         *
         * @type {HTMLElement}
         */
        const target = e.target;

        this.close(target.closest(".popup"));
      }
    });

    /*Close in outside container*/

    document.addEventListener("click", (e) => {
      if (!e.target.matches(".popup")) return;
      e.preventDefault();
      /**
       *
       * @type {HTMLElement}
       */
      const target = e.target;

      this.close(target);
    });
  }

  /**
   *
   * @param popup {HTMLElement}
   */
  open(popup) {
    clearTimeout(this.closeTimers.get(popup));
    popup.classList.remove("popup-hide");
    document.body.classList.add("overflow-hidden");
    popup.classList.add("popup-show");
  }

  /**
   *
   * @param popup {HTMLElement}
   */
  close(popup) {
    if (
      !popup.classList.contains("popup-show") ||
      popup.classList.contains("popup-hide")
    ) {
      return;
    }

    document.body.classList.remove("overflow-hidden");
    popup.classList.add("popup-hide");

    this.closeTimers.set(
      popup,
      setTimeout(() => {
        popup.classList.remove("popup-show");
        popup.classList.remove("popup-hide");
      }, this.animationDuration)
    );
  }

  openDefaultPopup() {
    let $this = this;
    const popup = document.querySelector("#cookie-popup");
    // The popup can be absent or hidden in the CMS with inline display: none
    if (!popup || popup.style.display === "none") return;
    if (typeof Cookies.get("popup") == "undefined") {
      setTimeout(function () {
        $this.open(popup);
        Cookies.set("popup", "1", { expires: 30, path: "/" });
      }, 3000);
    }
  }
}
